module.exports = __webpack_public_path__ + "static/virego_main_6-d6eecb1785834a51eeb9b941b9c9f7a2.png";